import "./App.css";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Home from "./Home";
import Services from "./Services";
import Contact from "./Contact";
import ServiceAreas from "./ServiceAreas";
import NotFound from "./NotFound";
import Footer from "./components/Footer";
import { CITY_PAGES, cityPath } from "./cityPages";
import ServicePage from "./ServicePage";
import { SERVICE_PAGES, servicePath } from "./servicePages";
import BlogIndex from "./BlogIndex";
import BlogFiftyFifty from "./Blogfiftyfifty";
import BlogRepairOrReplace from "./BlogRepairOrReplace";
import BrandPage from "./BrandPage";
import { BRAND_PAGES, brandPath } from "./Brands";
export default function App() {
  return (
    <Router>
      <div className="start">
        <img
          src="https://uploads-ssl.webflow.com/622b5f32e69caa8dd1db5ef6/624caa2018c7408693c5a542_phone-number-icon.svg"
          width="35" alt="" className="image-7"
        />
        {/* Phone must be a tappable link, and not a heading */}
        <a className="phone" href="tel:+13316004935">(331) 600-4935</a>
        <Link to="/contact" className="schedule-button">Schedule Service</Link>
      </div>

      <nav>
        <Link to="/" className="link">Home</Link>
        <Link to="/services" className="link">Our Services</Link>
        <Link to="/serviceareas" className="link">Service Areas</Link>
        <Link to="/contact" className="link">Contact Us</Link>
        <Link to="/blog" className="link">Blog</Link>

      </nav>

      <Routes>
        <Route index element={<Home />} />
        <Route path="services" element={<Services />} />
        <Route path="contact" element={<Contact />} />
        <Route path="serviceareas" element={<ServiceAreas />} />
        {CITY_PAGES.map(({ slug, Component }) => (
          <Route key={slug} path={cityPath(slug)} element={<Component />} />
        ))}
        {SERVICE_PAGES.map(({ slug }) => (
          <Route key={slug} path={servicePath(slug)} element={<ServicePage slug={slug} />} />
        ))}
        <Route path="*" element={<NotFound />} />
        <Route path="/blog" element={<BlogIndex />} />
        <Route path="/blog/50-50-payment-appliance-repair" element={<BlogFiftyFifty />} />
        <Route path="/blog/repair-or-replace-appliance" element={<BlogRepairOrReplace />} />
        {   BRAND_PAGES.map((b) => (
        <Route key={b.slug} path={brandPath(b.slug)} element={<BrandPage slug={b.slug} />} />
          ))}
      
      </Routes>

      <Footer />

      {/* Sticky call button for phones */}
      <a className="mobile-call" href="tel:+13316004935">Call (331) 600-4935</a>
    </Router>
  );
}